<template>
   <div class="simulateur-vue simulateur-credit-immobilier-vue">
       
        <div class="input-data-container">
            <div class="row" >
                
                <div class="columns medium-12 small-12 " > 
                    <div class="fields-container small">
                        <div class="field-group-title">Votre prêt</div>
                        <div class="form-input">
                            <label>
                                <cleave v-model="mensualites" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Mensualités souhaitées</span>
                                <span class="unit">€/mois</span>
                            </label>
                        </div>
                        <div class="form-input result">
                            <label>
                                <select v-model="duree"> 
                                    <option :value="taux.duree" v-for="taux in tauxSimulateurs">Sur {{taux.duree}} ans (Taux annuel à {{taux.taux.toFixed(2)}}%)</option>
                                </select>
                                <span class="placeholder">Durée et taux de votre prêt</span>
                            </label>
                        </div>
                        <div class="form-input">
                            <label>
                                <cleave v-model="apport" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Apport</span>
                                <span class="unit">€</span>
                            </label>
                        </div>   
                    
                    </div>
                </div>
            
                
            </div>
        </div>
        <div class="result-container">
            <div class="result-title">Résultats de votre simulation</div>
             <div v-if="error" class="flash-error">{{error}}</div>
            <div class="row">
                
                <div class="columns medium-12 small-12">
                    <div v-if="!error" class="fields-container "> 
                        <div class="field-group-title">Revenus requis</div>
                        <div class="field-group-info">Ci-dessous les revenus requis pour pouvoir prétendre à votre prêt. Ces revenus sont calculés selon un taux d'endettement de <span>{{tauxEndettement}}%</span></div>
                        <div class="form-input result">
                            <label>
                                <cleave disabled v-model="revenusMensuelsRequis" :options="cleaveOptionsDecimal"></cleave>
                            
                                <span class="placeholder">Revenus mensuels requis</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                        <div class="form-input result">
                            <label>
                                <cleave disabled v-model="revenusAnnuelsRequis" :options="cleaveOptionsDecimal"></cleave>
                            
                                <span class="placeholder">Revenus annuels requis</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                       
                    </div>
                </div>
        
                <div class="columns medium-12 small-12">
                    <div v-if="!error" class="fields-container "> 
                        <div class="field-group-title">Capacité de votre crédit</div>
                    
                         <div class="form-input result">
                            <label>
                                <cleave disabled v-model="capaciteEmprunt" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Capacité de votre crédit</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                        <div v-if="apport > 0" class="form-input result">
                            <label>
                                <cleave disabled v-model="capaciteProjet" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Capacité de votre projet (avec votre apport)</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                        <div class="form-input result">
                            <label>
                                <cleave disabled v-model="coutCredit" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Coût des intérêts du crédit seuls</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                        <div class="form-input result">
                            <label>
                                <cleave disabled v-model="coutTotal" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Coût total du crédit</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  mounted () {
    
    this.tauxSimulateurs = window.tauxSimulateurs
    this.tauxEndettement = parseFloat(window.tauxEndettement)
    let tmpDuree = this.tauxSimulateurs[0]
    if(tmpDuree) {
        this.duree = tmpDuree.duree
    }
  },
  data () {
    return {
      
      duree: null,
      tauxEndettement: 0,
      tauxSimulateurs: [],
      apport: null,
      mensualites: null,
      cleaveOptionsDecimal: {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: ' '
      },
      cleaveOptionsInteger: {
          numeral: true,
          numeralDecimalMark: '',
          delimiter: ' '
      },
    }
  },
  computed: {
    error () {
       return null
    },
    parsedMensualites () {
        return parseFloat( this.mensualites === null ? 0 : this.mensualites )
    },
    parsedApport () {
        return parseFloat( this.apport === null ? 0 : this.apport )
    },
    revenusMensuelsRequis () {
        return this.parsedMensualites * (1 / this.tauxEndettementSousUn)
    },

    revenusAnnuelsRequis () {
        return this.revenusMensuelsRequis * 12
    },
    
    capaciteEmprunt () {
       
        return (((1 -  Math.pow( 1 + this.tauxMensuelSousUn  , -this.dureeCreditEnMois)) * this.parsedMensualites ) /  this.tauxMensuelSousUn)
    },
    capaciteProjet () {
       return this.capaciteEmprunt + parseFloat(this.parsedApport === null ? 0 : this.parsedApport)
    },

    coutCredit () {
       return this.coutTotal - this.capaciteEmprunt
    },

    coutTotal () {
       return (this.dureeCreditEnMois * this.parsedMensualites) 
    },
   
 
    tauxEndettementSousUn () {
        return parseFloat(this.tauxEndettement) / 100
    },
    dureeCreditEnMois () {
      return this.duree * 12
    },
    tauxAnnuel () {
        let item = this.tauxSimulateurs.find((item) => {
            if(item.duree === this.duree) {
                return item
            }
        })
        if(item) {
            return item.taux
        }
    },
    tauxAnnuelSousUn () {
      return this.tauxAnnuel / 100
    },
    tauxMensuelSousUn () {
      return this.tauxAnnuelSousUn / 12
    },
  },
  methods: {
    calculate () {
      
    }

  }
}
</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/js/vue/components/SimulateurCalculCreditImmobilier.vue